import React, { useState, useEffect } from "react";
import "./App.css";
import translations from "./translations";
import { IoMail, IoLogoWhatsapp } from "react-icons/io5";
import { FaSquarePhone } from "react-icons/fa6";

function App() {
    const [language, setLanguage] = useState("gu");
    const [showWarning, setShowWarning] = useState(false);
    const [mailtoLink, setMailtoLink] = useState("");
    const [emailBody, setEmailBody] = useState("");
    const [showChromePopup, setShowChromePopup] = useState(true);

    useEffect(() => {
        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        if (!isChrome) {
            setShowChromePopup(true);
        }
    }, []);
    
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
        const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
        const isInAppBrowser =
            userAgent.includes("wv") || // Android WebView
            userAgent.includes("FBAN") || userAgent.includes("FBAV") || // Facebook
            userAgent.includes("Instagram") ||
            userAgent.includes("Line") ||
            userAgent.includes("Google") || // Google app
            (isIOS && !isSafari);

        if (isInAppBrowser) {
            setShowWarning(true);
        }
    }, []);

    useEffect(() => {
        const subject = translations[language].subject;
        const body = translations[language].emailBody;
        const toEmail = "ucc@gujarat.gov.in";
        const bccEmails = "aimrejectuccguj4@gmail.com";
        const replyToEmail = "aimplbmuit@gmail.com";
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        const link = isMobile
            ? `mailto:${toEmail}?bcc=${encodeURIComponent(bccEmails)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
            : `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(toEmail)}&bcc=${encodeURIComponent(bccEmails)}&reply-to=${encodeURIComponent(replyToEmail)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        setMailtoLink(link);
        setEmailBody(`To: ${toEmail}\nBCC: ${bccEmails}\nSubject: ${subject}\n\n${body}`);
    }, [language]);

    console.log(emailBody);
    return (
        
        <div className="app-container">
 
            {showWarning && (
                <div className="popup">
                    <div className="popup-content">
                        <p>
                            For the best experience, please open this page in your browser (like Chrome or Safari). QR scanners like Google Lens may limit functionality.
                        </p>
                        <button onClick={() => setShowWarning(false)}>OK</button>
                    </div>
                </div>
            )}

            <div className="content-container">
                {/* Left Content (70%) */}
                <div className="text-content">
                    <img src="logo.png" alt="All India Muslim Personal Law Board Logo" className="logo" />
                    <p className="greeting">{translations[language].greeting}</p>
                    <div className="message-block">
                        {translations[language].message.split("\n").map((line, idx) => (
                            <p key={idx} style={{ marginBottom: "8px" }}>{line.trim()}</p>
                        ))}
                    </div>
                    <p className="greeting"><b>{translations[language].instruction}</b></p>

                    <div className="greeting">
                        <label htmlFor="language-select">{translations[language].langLabel}</label>
                        <select className="emailbutton" id="language-select" onChange={(e) => setLanguage(e.target.value)} value={language}>
                            <option value="en">English</option>
                            <option value="hi">हिन्दी</option>
                            <option value="gu">ગુજરાતી</option>
                            <option value="ur">اردو</option>
                        </select>

                        {/* <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "10px" }}> */}
                    <a href={mailtoLink} target="_blank" rel="noopener noreferrer">
                          <button className="emailbutton">{translations[language].emailBtn}</button>
                    </a>

                    {showChromePopup && (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "1px",
            marginTop: "1px",
            fontSize: "13px",
            borderRadius: "1px",
            textAlign: "center"
        }}
    >
        <span style={{ color: "red" }}>
            {translations[language].openGmailIssueLabel}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "1px" }}>
            <span style={{ fontWeight: "bold", color: "#0056b3" }}>
                https://uccgj.pages.dev
            </span>
            <button
                onClick={() => navigator.clipboard.writeText("https://uccgj.pages.dev")}
                style={{
                    border: "none",
                    borderRadius: "4px",
                    padding: "4px 8px",
                    fontSize: "12px",
                    cursor: "pointer",
                    backgroundColor: "#ffac33"
                }}
            >
                Copy
            </button>
        </div>
    </div>
)}

{/* </div> */}


                    </div>
                </div>

                {/* Right Video Tutorial (30%) */}
                <div className="video-container">
                    <div className="video-box">
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/IcyNHySyWcM?si=qMCbMybFbjimPocP"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>

            {/* Full-Width Footer */}
            <footer>
                <strong>{translations[language].footer} : </strong>  
                <FaSquarePhone className="email-icon" /> &nbsp;
                <span className="phone-numbers">
                    93392 59009 | 9904467110 | 9722258206 
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <IoMail className="email-icon" /> 
                <a href="mailto:aimplbmuit@gmail.com">aimplbmuit@gmail.com</a>
                <br /><br/>
                <strong>{translations[language].wachannel} </strong>  
                <IoLogoWhatsapp className="whatsapp-icon" /> 
                <a href="https://tinyurl.com/uccupdate">https://tinyurl.com/uccupdate</a>
            </footer>
        </div>
    );
}

export default App;
